import { createAuthClient } from 'better-auth/react';
import {
  adminClient,
  magicLinkClient,
  twoFactorClient,
} from 'better-auth/client/plugins';
import { ac, admin as adminRole, investor, founder } from './permissions';

/**
 * Auth Client for Purple Venture Studios
 * Provides client-side authentication and authorization capabilities
 *
 * Features:
 * - Email/password, Google OAuth, and Magic Link authentication
 * - Admin operations (user management, role assignment, impersonation)
 * - Client-side permission checking for conditional UI rendering
 */
export const authClient = createAuthClient({
  baseURL: process.env.BETTER_AUTH_URL || 'http://localhost:3000',
  fetchOptions: {
    credentials: 'include', // Ensure cookies are sent with cross-origin requests
  },
  plugins: [
    // Magic Link authentication (for founders)
    magicLinkClient(),

    // Admin operations and permission checking
    adminClient({
      ac,
      roles: {
        admin: adminRole,
        investor,
        founder,
      },
    }),

    // Two-Factor Authentication
    twoFactorClient(),
  ],
});
